import { render, staticRenderFns } from "./PositionsPanel.vue?vue&type=template&id=79dcb52a&scoped=true"
import script from "./PositionsPanel.vue?vue&type=script&lang=js"
export * from "./PositionsPanel.vue?vue&type=script&lang=js"
import style0 from "./PositionsPanel.vue?vue&type=style&index=0&id=79dcb52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dcb52a",
  null
  
)

export default component.exports